import { isEmailLikeDisplayLabel } from '../utils/headerDisplayName';
import { decodeJwtPayload } from './jwtPayload';

function pickString(...vals: unknown[]): string | null {
  for (const v of vals) {
    if (typeof v === 'string' && v.trim()) {
      return v.trim();
    }
  }
  return null;
}

function nameFromUserObject(user: Record<string, unknown>): string | null {
  return pickString(
    user.name,
    user.displayName,
    [user.firstName, user.lastName]
      .filter((x) => typeof x === 'string')
      .join(' ')
      .trim() || null,
    [user.first_name, user.last_name]
      .filter((x) => typeof x === 'string')
      .join(' ')
      .trim() || null,
    user.email,
    user.username,
  );
}

function displayNameFromJwt(token: string): string | null {
  const p = decodeJwtPayload(token);
  if (!p) {
    return null;
  }
  const firstLast =
    (typeof p.given_name === 'string' && typeof p.family_name === 'string' && `${p.given_name} ${p.family_name}`.trim()) ||
    null;
  const partialName = pickString(
    firstLast,
    [p.given_name, p.family_name]
      .filter((x) => typeof x === 'string')
      .join(' ')
      .trim() || null,
    p.given_name,
    p.family_name,
  );
  if (partialName) {
    return partialName;
  }
  const jwtName = pickString(p.name, p.preferred_username);
  if (jwtName && !isEmailLikeDisplayLabel(jwtName)) {
    return jwtName;
  }
  return pickString(jwtName, p.email, p.unique_name, p.sub);
}

/**
 * Picks a label for the top bar from the login JSON, JWT, or the identifier the user typed.
 */
export function displayNameFromLogin(
  body: unknown,
  accessToken: string,
  loginIdentifier: string,
): string {
  if (body && typeof body === 'object') {
    const o = body as Record<string, unknown>;
    const joinedTop =
      [o.first_name, o.last_name]
        .filter((x) => typeof x === 'string')
        .join(' ')
        .trim() || null;
    const top = pickString(o.name, o.displayName, o.username, joinedTop);
    if (top && !isEmailLikeDisplayLabel(top)) {
      return top;
    }
    if (joinedTop) {
      return joinedTop;
    }
    const emailTop = pickString(o.email);
    if (emailTop) {
      return emailTop;
    }
    if (top) {
      return top;
    }
    if (o.user && typeof o.user === 'object') {
      const u = nameFromUserObject(o.user as Record<string, unknown>);
      if (u) {
        return u;
      }
    }
  }
  const fromJwt = displayNameFromJwt(accessToken);
  if (fromJwt) {
    return fromJwt;
  }
  if (loginIdentifier.trim()) {
    return loginIdentifier.trim();
  }
  return 'User';
}
